import React from 'react';
import Modal from 'src/components/Modal';
import { Box, Button, Paragraph } from 'grommet';

interface Props {
  isShow: boolean;
  onConfirm: () => void;
  onCancel: () => void;
  children: JSX.Element | string;
}

function ConfirmModal({ isShow, onConfirm, onCancel, children }: Props): JSX.Element | null {
  return (
    <Modal isShow={isShow} onRequestClose={onCancel}>
      <Box direction='column' pad='small'>
        <Paragraph margin='none'>{children}</Paragraph>
        <Box direction='row' gap='small' margin={{ top: 'small' }}>
          <Button primary label='OK' onClick={onConfirm} />
          <Button label='Cancel' onClick={onCancel} />
        </Box>
      </Box>
    </Modal>
  );
}

export default ConfirmModal;
